import moment from "moment";

type DateLike = string | Date | moment.Moment;

export function formatDateTime(value?: DateLike, format?: string) {
  if (value) {
    return moment(value).format(format || "l LT");
  }
}

export function formatDate(value?: DateLike, format?: string) {
  return formatDateTime(value, format || "ll");
}

export function formatTime(value?: DateLike, format?: string) {
  return formatDateTime(value, format || "LT");
}

/**
 * Uses moment.js's fromNow format.
 * @param value: Time to get format of. This should be in UTC
 */
export function formatTimeFromNow(value?: DateLike) {
  if (value) {
    return moment.utc(value).fromNow();
  }
}

export function formatAge(value?: DateLike): string | undefined {
  if (value) {
    const now = moment();

    const years = now.diff(value, "years");
    if (years >= 2) return `${years}`;

    const months = now.diff(value, "months");
    if (months >= 3) return `${months}m`;

    const weeks = now.diff(value, "weeks");
    if (weeks >= 9) return `${weeks}w`;

    const days = now.diff(value, "days");
    if (days < 1) return "< 1d";
    else return `${days}d`;
  }
}
